import axios from "axios";
import { getConfig } from "../../../../ApiHelpers/ApiDefaultConfig";
export const extractData = async (): Promise<any | null> => {
    let config = getConfig()
    let result: any | null = null
    try {
        const response = await axios.post(`/extract`, {}, config)
        result = response.data
    } catch (error) {
        console.log(error, 'error')
    }

    return result
}
